import { Cancel } from 'iconoir-react';
import React, { useState, useEffect } from 'react'
import Button from '../Button';
import { useDispatch, useSelector } from 'react-redux'
import { getAllPromotions } from '../../../redux_store/promotions/promotion_thunk';
import InputField from '../InputField';
import moment from 'moment';

const ApplyPromoModal = ({onCancel, user, onSubmit}) => {
  const dispatch = useDispatch();
  const [showDropDown, setShowDropDown] = useState(false);
  const [addedPromos, setAddedPromos] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState('');
  const { promotions } = useSelector((state)=>state.promotion);

  useEffect(() => {
    dispatch(getAllPromotions());
    // eslint-disable-next-line
  }, [])  

  useEffect(()=>{
    if(Array.isArray(promotions)){
      setAddedPromos(promotions)
    }
  }, [promotions])

  return (
    <div className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>Apply Promotion</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <div className='my-5'>
            <InputField
              value={selectedPromo.promo_code} 
              size="small"
              type={'text'}            
              placeholder={'Search promo by code or type'}
              onChange={(e)=>{
                const {value} = e.target;
                setShowDropDown(true);
                const searchedPromo = promotions.filter((promo)=>
                  promo.promo_type.toLowerCase().includes(value.toLowerCase()) ||
                  promo.promo_code.toLowerCase().includes(value.toLowerCase())
                );
                setSelectedPromo(value);
                setAddedPromos(searchedPromo);
              }}
            />
          {showDropDown &&           
            <div style={{ width: '100%', maxHeight: '300px' }} className='border-gray-300 overflow-y-auto bg-white relative cursor-pointer z-50 shadow-md shadow-slate-400 rounded'>
              {addedPromos && addedPromos.map((promo)=>
                <section onClick={()=>{
                  setShowDropDown(false);
                  setSelectedPromo({promo_code: promo.promo_code, user_id: user.id});
                }} className='my-1 border-t hover:bg-slate-100 py-1 px-2' value={`${promo.promo_code} (${promo.promo_type})`}>
                  <p className='text-sm my-1 text-blue-600'>Code: {promo.promo_code}</p>
                  <p className='text-xs my-1 text-gray-500'>Value: {promo.promo_type.toLowerCase() === 'percentage' ? `${promo.value}%`: `GHC ${promo.value}`}</p>
                  <p className='text-xs my-1 text-gray-500'>Expires: {moment(promo.expiry_date).format('dddd ll')}</p>
                </section>
              )}
            </div>
          }
          </div>
          <br />
          <br />
          <Button
            label={'Submit'}
            width="w-full"
            onClick={()=>onSubmit(selectedPromo)}
            bgColor={'wayrideBgColor'}
          />
        </div>
      </div>
    </div>
  )
}

export default ApplyPromoModal